import logging from '@sstdev/lib_logging';
import { executeForEach } from '../registeredServiceQueues';
import { uiRuntimeConfig, constants } from 'lib_ui-services';

const _p = {
    executeForEach
};

export const _private = _p;
export default {
    verb: 'doingCreate',
    namespace: 'sensor',
    relation: 'tag',
    description: 'Interact with native code to actually encode a physical tag',
    useCaseIds: [constants.useCaseIds.ITEM_TRACKING, constants.useCaseIds.WORK_IN_PROCESS, constants.useCaseIds.RFID],
    logic,
    onError
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @template T
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function logic({ data, context, dispatch }) {
    const { newRecord } = data;
    // don't catch errors, as we want them to be displayed on the form.
    const sensorType = newRecord.sensorType || constants.sensorTypes.RFID;
    const response = await _p.executeForEach('encode', { sensorType, ...newRecord }, context);
    if (response.find(r => r.type === sensorType)?.result == '') {
        logging.debug(`[${sensorType}] Encoding ${newRecord.value} succeeded`);
        dispatch(
            {
                isError: false, //todo: gl2025 remove
                variant: 'success',
                type: constants.notificationTypes.TOAST,
                message: 'Tag Encoding Successful!',
                timeout: uiRuntimeConfig.getNotificationTimeout()
            },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );

        // ignoreChanges tells form machine to not treat this as canceling on a dirty form
        // which was causing it to display an "Are you sure you want to cancel?" message
        return { ...data, ignoreChanges: true };
    } else {
        const message = response[0].result || 'Unable to encode tags at this time';
        throw new Error(message);
    }
}

/**
 * @param {{
 *      error: Error;
 *      data: T;
 *      context: Context;
 *      dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>,
 *      workflowStack: WorkflowStack[]
 * }} parameters
 * */
function onError({ error, dispatch }) {
    //Errors don't work on Single Record forms, and I don't have time to figure out why.

    // If error is "Operation In Progress-Command Not Allowed", show a more helpful message.
    // I've only gotten this error by moving the tag and reader away from each other mid-read.
    // If this modified error message is showing up for other reasons, we may need to change how we handle this.
    let modifiedErrorMessage;
    if (error.message.includes('Operation In Progress')) {
        modifiedErrorMessage = 'Failed to encode tag. Please reposition tag or device and try again.';
    }

    dispatch(
        {
            isError: true, //todo: gl2025 remove
            variant: 'error',
            type: constants.notificationTypes.TOAST,
            message: modifiedErrorMessage || error.message || error,
            timeout: uiRuntimeConfig.getNotificationTimeout()
        },
        { verb: 'pop', namespace: 'application', relation: 'notification' }
    );

    // throw error;
    // return data;
}
